export enum ETripsEventName {
  CLAIMS_CAROUSEL_OPENED = 'Claims Carousel Opened',
  CLAIMS_CAROUSEL_VIEWED = 'Claims Carousel Viewed',
  RENTER_BOOKING_EPISODIC_UPDATED = 'Renter Booking Episodic Updated',
}

export interface IClaimsCarouselViewedEventInfo {
  slideNumber: number;
}

export interface IRenterBookingEpisodicUpdatedEventInfo {
  bookingID: number;
  oldBundle: string;
  newBundle: string;
  oldCost: number;
  newCost: number;
}
